import { Link } from 'react-router-dom';

const LocationsSection = () => (
  <section className="border-t border-b border-[#d4eddf]" style={{ background: 'linear-gradient(180deg, #edf8f2 0%, #f7fcf9 60%, #ffffff 100%)' }}>
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-8">
      <p className="text-center text-xs font-bold uppercase tracking-widest text-[#1B6B3A] mb-6">Our 2 Drop-Off Locations</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* Location 1 */}
        <div
          className="relative overflow-hidden rounded-2xl px-7 py-6 flex items-center gap-6"
          style={{ background: 'linear-gradient(135deg, #1B6B3A 0%, #24913f 100%)' }}
        >
          <div className="absolute -top-6 -right-6 w-36 h-36 rounded-full opacity-10 bg-white pointer-events-none" />
          <div className="absolute bottom-0 right-2 w-20 h-20 rounded-full opacity-10 bg-white pointer-events-none" />

          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 shrink-0">
            <i className="ri-building-2-line text-white text-3xl"></i>
          </div>

          <div className="flex-1 min-w-0">
            <span className="text-[10px] font-extrabold uppercase tracking-widest text-white/60">Location 1</span>
            <h3 className="text-white font-extrabold text-xl leading-tight mt-0.5 mb-1">Downtown / Koreatown</h3>
            <p className="text-white font-bold text-base leading-snug">2542 W. 3rd Street</p>
            <p className="text-white/80 font-semibold text-sm">Los Angeles, CA 90057</p>
            <p className="text-white/70 text-xs font-semibold mt-1 mb-3 flex items-center gap-1">
              <i className="ri-time-line"></i> Mon–Fri &nbsp;8am – 6pm
            </p>
            <div className="flex flex-wrap gap-2">
              <a
                href="https://maps.google.com/?q=2542+W+3rd+Street+Los+Angeles+CA+90057"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-1.5 bg-white text-[#1B6B3A] font-extrabold text-xs px-4 py-2 rounded-full hover:bg-green-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-pin-line"></i>
                Get Directions
              </a>
              <Link
                to="/locations/west-3rd-street"
                className="inline-flex items-center gap-1.5 bg-white/20 text-white font-extrabold text-xs px-4 py-2 rounded-full hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-right-line"></i>
                View Page
              </Link>
            </div>
          </div>
        </div>

        {/* Location 2 */}
        <div
          className="relative overflow-hidden rounded-2xl px-7 py-6 flex items-center gap-6"
          style={{ background: 'linear-gradient(135deg, #b45309 0%, #d97706 100%)' }}
        >
          <div className="absolute -top-6 -right-6 w-36 h-36 rounded-full opacity-10 bg-white pointer-events-none" />
          <div className="absolute bottom-0 right-2 w-20 h-20 rounded-full opacity-10 bg-white pointer-events-none" />

          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 shrink-0">
            <i className="ri-map-pin-2-line text-white text-3xl"></i>
          </div>

          <div className="flex-1 min-w-0">
            <span className="text-[10px] font-extrabold uppercase tracking-widest text-white/60">Location 2</span>
            <h3 className="text-white font-extrabold text-xl leading-tight mt-0.5 mb-1">South LA / Inglewood</h3>
            <p className="text-white font-bold text-base leading-snug">4902 W. Slauson Ave</p>
            <p className="text-white/80 font-semibold text-sm">Los Angeles, CA 90056</p>
            <p className="text-white/70 text-xs font-semibold mt-1 mb-3 flex items-center gap-1">
              <i className="ri-time-line"></i> Mon–Sat &nbsp;11am – 5pm
            </p>
            <div className="flex flex-wrap gap-2">
              <a
                href="https://maps.google.com/?q=4902+W+Slauson+Ave+Los+Angeles+CA+90056"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-1.5 bg-white text-[#b45309] font-extrabold text-xs px-4 py-2 rounded-full hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-pin-line"></i>
                Get Directions
              </a>
              <Link
                to="/locations/slauson-ave"
                className="inline-flex items-center gap-1.5 bg-white/20 text-white font-extrabold text-xs px-4 py-2 rounded-full hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-right-line"></i>
                View Page
              </Link>
            </div>
          </div>
        </div>

      </div>
      <p className="text-center text-xs text-gray-400 mt-5">
        Can&apos;t make it? &nbsp;
        <Link to="/pickup-request" className="text-[#1B6B3A] font-semibold hover:underline cursor-pointer whitespace-nowrap">
          Schedule a free pickup &rarr;
        </Link>
      </p>
    </div>
  </section>
);

export default LocationsSection;
